import { ColumnConfig, ProductPerformanceReportColumnKey } from '../../model';

export const ProductPerformanceReportConfig: Record<
  ProductPerformanceReportColumnKey,
  ColumnConfig
> = {
  sNo: {
    name: 'S.No',
  },
  productName: {
    name: 'Product Name',
  },
  sku: {
    name: 'Sku',
  },
  noOfOrders: {
    name: 'Total Orders',
    alignment: 'flex-end',
  },
  totalQty: {
    name: 'Total Qty',
    alignment: 'flex-end',
  },
  totalValue: {
    name: 'Total Value',
    alignment: 'flex-end',
  },
  avgSellingPrice: {
    name: 'Avg Selling Price',
    alignment: 'flex-end',
  },
  category: {
    name: 'Category',
  },
};
